import { useSelector } from "react-redux";
import { IMainReduxState } from "core/interfaces.config";

const useMainState = (): IMainReduxState =>
  useSelector((reducers: IMainReduxState) => reducers);

export default useMainState;
